/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createDiffusionList } from '../fn/diffusion-list/create-diffusion-list';
import { CreateDiffusionList$Params } from '../fn/diffusion-list/create-diffusion-list';
import { createTechnicalAccount } from '../fn/technical-accounts/create-technical-account';
import { CreateTechnicalAccount$Params } from '../fn/technical-accounts/create-technical-account';
import { createUser } from '../fn/users/create-user';
import { CreateUser$Params } from '../fn/users/create-user';
import { deleteDiffusionList } from '../fn/diffusion-list/delete-diffusion-list';
import { DeleteDiffusionList$Params } from '../fn/diffusion-list/delete-diffusion-list';
import { deleteTechnicalAccount } from '../fn/technical-accounts/delete-technical-account';
import { DeleteTechnicalAccount$Params } from '../fn/technical-accounts/delete-technical-account';
import { deleteUser } from '../fn/users/delete-user';
import { DeleteUser$Params } from '../fn/users/delete-user';
import { DiffusionListPaged } from '../models/diffusion-list-paged';
import { exportSubscribedUsers } from '../fn/subscriptions/export-subscribed-users';
import { ExportSubscribedUsers$Params } from '../fn/subscriptions/export-subscribed-users';
import { exportUserConfiguration } from '../fn/users/export-user-configuration';
import { ExportUserConfiguration$Params } from '../fn/users/export-user-configuration';
import { findUserByLogin } from '../fn/users/find-user-by-login';
import { FindUserByLogin$Params } from '../fn/users/find-user-by-login';
import { getAllTechnicalAccounts } from '../fn/technical-accounts/get-all-technical-accounts';
import { GetAllTechnicalAccounts$Params } from '../fn/technical-accounts/get-all-technical-accounts';
import { getTechnicalAccount } from '../fn/technical-accounts/get-technical-account';
import { GetTechnicalAccount$Params } from '../fn/technical-accounts/get-technical-account';
import { getTransactionsOfUser } from '../fn/transactions/get-transactions-of-user';
import { GetTransactionsOfUser$Params } from '../fn/transactions/get-transactions-of-user';
import { getUser } from '../fn/users/get-user';
import { GetUser$Params } from '../fn/users/get-user';
import { getUserFavoriteStations } from '../fn/users/get-user-favorite-stations';
import { GetUserFavoriteStations$Params } from '../fn/users/get-user-favorite-stations';
import { getUserOfSubscription } from '../fn/subscriptions/get-user-of-subscription';
import { GetUserOfSubscription$Params } from '../fn/subscriptions/get-user-of-subscription';
import { getUsers } from '../fn/users/get-users';
import { GetUsers$Params } from '../fn/users/get-users';
import { getUsersOfSubscription } from '../fn/subscriptions/get-users-of-subscription';
import { GetUsersOfSubscription$Params } from '../fn/subscriptions/get-users-of-subscription';
import { importNewUsersToSubscribe } from '../fn/subscriptions/import-new-users-to-subscribe';
import { ImportNewUsersToSubscribe$Params } from '../fn/subscriptions/import-new-users-to-subscribe';
import { importUserConfiguration } from '../fn/users/import-user-configuration';
import { ImportUserConfiguration$Params } from '../fn/users/import-user-configuration';
import { resetPasswordUser } from '../fn/users/reset-password-user';
import { ResetPasswordUser$Params } from '../fn/users/reset-password-user';
import { retrieveDiffusionList } from '../fn/diffusion-list/retrieve-diffusion-list';
import { RetrieveDiffusionList$Params } from '../fn/diffusion-list/retrieve-diffusion-list';
import { searchDiffusionLists } from '../fn/diffusion-list/search-diffusion-lists';
import { searchDiffusionLists$Any } from '../fn/diffusion-list/search-diffusion-lists-any';
import { SearchDiffusionLists$Any$Params } from '../fn/diffusion-list/search-diffusion-lists-any';
import { SearchDiffusionLists$Params } from '../fn/diffusion-list/search-diffusion-lists';
import { searchTechnicalAccount } from '../fn/technical-accounts/search-technical-account';
import { SearchTechnicalAccount$Params } from '../fn/technical-accounts/search-technical-account';
import { searchUsers } from '../fn/users/search-users';
import { searchUsers$Any } from '../fn/users/search-users-any';
import { SearchUsers$Any$Params } from '../fn/users/search-users-any';
import { SearchUsers$Params } from '../fn/users/search-users';
import { searchUsersFavoriteStations } from '../fn/users/search-users-favorite-stations';
import { searchUsersFavoriteStations$Any } from '../fn/users/search-users-favorite-stations-any';
import { SearchUsersFavoriteStations$Any$Params } from '../fn/users/search-users-favorite-stations-any';
import { SearchUsersFavoriteStations$Params } from '../fn/users/search-users-favorite-stations';
import { SingleDiffusionList } from '../models/single-diffusion-list';
import { StationList } from '../models/station-list';
import { subscribeUsersToSubscription } from '../fn/subscriptions/subscribe-users-to-subscription';
import { SubscribeUsersToSubscription$Params } from '../fn/subscriptions/subscribe-users-to-subscription';
import { SubscriptionUser } from '../models/subscription-user';
import { SubscriptionUsersPagedList } from '../models/subscription-users-paged-list';
import { TechnicalAccount } from '../models/technical-account';
import { TechnicalAccountList } from '../models/technical-account-list';
import { TransactionPagedList } from '../models/transaction-paged-list';
import { unsubscribeUsersFromSubscription } from '../fn/subscriptions/unsubscribe-users-from-subscription';
import { UnsubscribeUsersFromSubscription$Params } from '../fn/subscriptions/unsubscribe-users-from-subscription';
import { updateDiffusionList } from '../fn/diffusion-list/update-diffusion-list';
import { UpdateDiffusionList$Params } from '../fn/diffusion-list/update-diffusion-list';
import { updateTechnicalAccount } from '../fn/technical-accounts/update-technical-account';
import { UpdateTechnicalAccount$Params } from '../fn/technical-accounts/update-technical-account';
import { updateUser } from '../fn/users/update-user';
import { UpdateUser$Params } from '../fn/users/update-user';
import { User } from '../models/user';
import { userAddAuthSupports } from '../fn/subscriptions/user-add-auth-supports';
import { UserAddAuthSupports$Params } from '../fn/subscriptions/user-add-auth-supports';
import { userAddVehicles } from '../fn/subscriptions/user-add-vehicles';
import { UserAddVehicles$Params } from '../fn/subscriptions/user-add-vehicles';
import { UserFavoriteStationsList } from '../models/user-favorite-stations-list';
import { UserList } from '../models/user-list';
import { userRemoveAuthSupports } from '../fn/subscriptions/user-remove-auth-supports';
import { UserRemoveAuthSupports$Params } from '../fn/subscriptions/user-remove-auth-supports';
import { userRemoveVehicles } from '../fn/subscriptions/user-remove-vehicles';
import { UserRemoveVehicles$Params } from '../fn/subscriptions/user-remove-vehicles';
import { UserSummary } from '../models/user-summary';


/**
 * All about the contacts
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllTechnicalAccounts()` */
  static readonly GetAllTechnicalAccountsPath = '/technical-accounts';

  /**
   * Get technical accounts.
   *
   * Get all technical accounts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTechnicalAccounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnicalAccounts$Response(params?: GetAllTechnicalAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
    return getAllTechnicalAccounts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get technical accounts.
   *
   * Get all technical accounts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTechnicalAccounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTechnicalAccounts(params?: GetAllTechnicalAccounts$Params, context?: HttpContext): Observable<TechnicalAccountList> {
    return this.getAllTechnicalAccounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccountList>): TechnicalAccountList => r.body)
    );
  }

  /** Path part for operation `createTechnicalAccount()` */
  static readonly CreateTechnicalAccountPath = '/technical-accounts';

  /**
   * Create a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTechnicalAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechnicalAccount$Response(params: CreateTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTechnicalAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTechnicalAccount(params: CreateTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.createTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTechnicalAccount()` */
  static readonly GetTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Get a technical account.
   *
   * Get a technical account
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechnicalAccount$Response(params: GetTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccount>> {
    return getTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a technical account.
   *
   * Get a technical account
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechnicalAccount(params: GetTechnicalAccount$Params, context?: HttpContext): Observable<TechnicalAccount> {
    return this.getTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccount>): TechnicalAccount => r.body)
    );
  }

  /** Path part for operation `updateTechnicalAccount()` */
  static readonly UpdateTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Update a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTechnicalAccount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechnicalAccount$Response(params: UpdateTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTechnicalAccount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTechnicalAccount(params: UpdateTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.updateTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTechnicalAccount()` */
  static readonly DeleteTechnicalAccountPath = '/technical-accounts/{uid}';

  /**
   * Deactivate a technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechnicalAccount$Response(params: DeleteTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Deactivate a technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTechnicalAccount(params: DeleteTechnicalAccount$Params, context?: HttpContext): Observable<void> {
    return this.deleteTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchTechnicalAccount()` */
  static readonly SearchTechnicalAccountPath = '/technical-accounts/search';

  /**
   * Search through all technical account.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTechnicalAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTechnicalAccount$Response(params?: SearchTechnicalAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
    return searchTechnicalAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * Search through all technical account.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTechnicalAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchTechnicalAccount(params?: SearchTechnicalAccount$Params, context?: HttpContext): Observable<TechnicalAccountList> {
    return this.searchTechnicalAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<TechnicalAccountList>): TechnicalAccountList => r.body)
    );
  }

  /** Path part for operation `subscribeUsersToSubscription()` */
  static readonly SubscribeUsersToSubscriptionPath = '/subscriptions/{uid}/users/subscribe';

  /**
   * Subscribe user to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeUsersToSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeUsersToSubscription$Response(params: SubscribeUsersToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeUsersToSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Subscribe user to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeUsersToSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeUsersToSubscription(params: SubscribeUsersToSubscription$Params, context?: HttpContext): Observable<void> {
    return this.subscribeUsersToSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `unsubscribeUsersFromSubscription()` */
  static readonly UnsubscribeUsersFromSubscriptionPath = '/subscriptions/{uid}/users/unsubscribe';

  /**
   * Unsubscribe user from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unsubscribeUsersFromSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  unsubscribeUsersFromSubscription$Response(params: UnsubscribeUsersFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return unsubscribeUsersFromSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Unsubscribe user from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unsubscribeUsersFromSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  unsubscribeUsersFromSubscription(params: UnsubscribeUsersFromSubscription$Params, context?: HttpContext): Observable<void> {
    return this.unsubscribeUsersFromSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUsersOfSubscription()` */
  static readonly GetUsersOfSubscriptionPath = '/subscriptions/{uid}/users';

  /**
   * Retrieve a list of service customers of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersOfSubscription$Response(params: GetUsersOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUsersPagedList>> {
    return getUsersOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of service customers of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersOfSubscription(params: GetUsersOfSubscription$Params, context?: HttpContext): Observable<SubscriptionUsersPagedList> {
    return this.getUsersOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionUsersPagedList>): SubscriptionUsersPagedList => r.body)
    );
  }

  /** Path part for operation `getUserOfSubscription()` */
  static readonly GetUserOfSubscriptionPath = '/subscriptions/{uid}/users/{userUid}';

  /**
   * Retrieve an user of a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOfSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOfSubscription$Response(params: GetUserOfSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionUser>> {
    return getUserOfSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve an user of a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserOfSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOfSubscription(params: GetUserOfSubscription$Params, context?: HttpContext): Observable<SubscriptionUser> {
    return this.getUserOfSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionUser>): SubscriptionUser => r.body)
    );
  }

  /** Path part for operation `exportSubscribedUsers()` */
  static readonly ExportSubscribedUsersPath = '/subscriptions/{uid}/users/export';

  /**
   * Export  the contacts and auth supports assigned to this subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscribedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscribedUsers$Response(params: ExportSubscribedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscribedUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the contacts and auth supports assigned to this subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscribedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscribedUsers(params: ExportSubscribedUsers$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscribedUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importNewUsersToSubscribe()` */
  static readonly ImportNewUsersToSubscribePath = '/subscriptions/{uid}/users/import';

  /**
   * Import the contacts and auth supports to add to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importNewUsersToSubscribe()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNewUsersToSubscribe$Response(params: ImportNewUsersToSubscribe$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importNewUsersToSubscribe(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the contacts and auth supports to add to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importNewUsersToSubscribe$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importNewUsersToSubscribe(params: ImportNewUsersToSubscribe$Params, context?: HttpContext): Observable<void> {
    return this.importNewUsersToSubscribe$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userAddAuthSupports()` */
  static readonly UserAddAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/assign';

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports$Response(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Add auth supports to a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddAuthSupports(params: UserAddAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userAddAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveAuthSupports()` */
  static readonly UserRemoveAuthSupportsPath = '/subscriptions/{uid}/users/{userUid}/auth-supports/remove';

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveAuthSupports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports$Response(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveAuthSupports(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove auth supports from a subscription and user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveAuthSupports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveAuthSupports(params: UserRemoveAuthSupports$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveAuthSupports$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userAddVehicles()` */
  static readonly UserAddVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/assign';

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userAddVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles$Response(params: UserAddVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userAddVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Add vehicles to a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userAddVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userAddVehicles(params: UserAddVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userAddVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `userRemoveVehicles()` */
  static readonly UserRemoveVehiclesPath = '/subscriptions/{uid}/users/{userUid}/vehicles/remove';

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRemoveVehicles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles$Response(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userRemoveVehicles(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove vehicles from a subscription and an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRemoveVehicles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRemoveVehicles(params: UserRemoveVehicles$Params, context?: HttpContext): Observable<void> {
    return this.userRemoveVehicles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfUser()` */
  static readonly GetTransactionsOfUserPath = '/users/{uid}/transactions';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfUser$Response(params: GetTransactionsOfUser$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfUser(params: GetTransactionsOfUser$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `searchUsers()` */
  static readonly SearchUsersPath = '/users/search';

  /**
   * Search contacts.
   *
   * Search contacts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsers$Response(params?: SearchUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserList>> {
    return searchUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Search contacts.
   *
   * Search contacts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsers(params?: SearchUsers$Params, context?: HttpContext): Observable<UserList> {
    return this.searchUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserList>): UserList => r.body)
    );
  }

  /**
   * Search contacts.
   *
   * Search contacts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsers$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsers$Any$Response(params?: SearchUsers$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UserList>> {
    return searchUsers$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search contacts.
   *
   * Search contacts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsers$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsers$Any(params?: SearchUsers$Any$Params, context?: HttpContext): Observable<UserList> {
    return this.searchUsers$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserList>): UserList => r.body)
    );
  }

  /** Path part for operation `getUsers()` */
  static readonly GetUsersPath = '/users';

  /**
   * Get contacts.
   *
   * Get all contacts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserList>> {
    return getUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get contacts.
   *
   * Get all contacts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params?: GetUsers$Params, context?: HttpContext): Observable<UserList> {
    return this.getUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserList>): UserList => r.body)
    );
  }

  /** Path part for operation `createUser()` */
  static readonly CreateUserPath = '/users';

  /**
   * Create a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params: CreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: CreateUser$Params, context?: HttpContext): Observable<void> {
    return this.createUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importUserConfiguration()` */
  static readonly ImportUserConfigurationPath = '/users/import';

  /**
   * Import the the Users Definition.
   *
   * Allows to import the Users Definition, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importUserConfiguration()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importUserConfiguration$Response(params?: ImportUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importUserConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the the Users Definition.
   *
   * Allows to import the Users Definition, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importUserConfiguration$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importUserConfiguration(params?: ImportUserConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.importUserConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportUserConfiguration()` */
  static readonly ExportUserConfigurationPath = '/users/export';

  /**
   * Export the Users Definition.
   *
   * Allows to export the the Users Definition.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportUserConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportUserConfiguration$Response(params?: ExportUserConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportUserConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the Users Definition.
   *
   * Allows to export the the Users Definition.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportUserConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportUserConfiguration(params?: ExportUserConfiguration$Params, context?: HttpContext): Observable<Blob> {
    return this.exportUserConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/users/{uid}';

  /**
   * get a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return getUser(this.http, this.rootUrl, params, context);
  }

  /**
   * get a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<User> {
    return this.getUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/users/{uid}';

  /**
   * Update a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<void> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteUser()` */
  static readonly DeleteUserPath = '/users/{uid}';

  /**
   * Delete a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(params: DeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: DeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.deleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resetPasswordUser()` */
  static readonly ResetPasswordUserPath = '/users/{uid}/reset-password';

  /**
   * Reset a user's password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPasswordUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetPasswordUser$Response(params: ResetPasswordUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return resetPasswordUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Reset a user's password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetPasswordUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetPasswordUser(params: ResetPasswordUser$Params, context?: HttpContext): Observable<void> {
    return this.resetPasswordUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUserFavoriteStations()` */
  static readonly GetUserFavoriteStationsPath = '/users/{uid}/favorite-stations';

  /**
   * Get a user's favorite stations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserFavoriteStations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFavoriteStations$Response(params: GetUserFavoriteStations$Params, context?: HttpContext): Observable<StrictHttpResponse<StationList>> {
    return getUserFavoriteStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a user's favorite stations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserFavoriteStations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserFavoriteStations(params: GetUserFavoriteStations$Params, context?: HttpContext): Observable<StationList> {
    return this.getUserFavoriteStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationList>): StationList => r.body)
    );
  }

  /** Path part for operation `searchUsersFavoriteStations()` */
  static readonly SearchUsersFavoriteStationsPath = '/users/favorite-stations/search';

  /**
   * Search contacts favorite stations.
   *
   * Search contacts favorite stations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsersFavoriteStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsersFavoriteStations$Response(params?: SearchUsersFavoriteStations$Params, context?: HttpContext): Observable<StrictHttpResponse<UserFavoriteStationsList>> {
    return searchUsersFavoriteStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Search contacts favorite stations.
   *
   * Search contacts favorite stations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsersFavoriteStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUsersFavoriteStations(params?: SearchUsersFavoriteStations$Params, context?: HttpContext): Observable<UserFavoriteStationsList> {
    return this.searchUsersFavoriteStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserFavoriteStationsList>): UserFavoriteStationsList => r.body)
    );
  }

  /**
   * Search contacts favorite stations.
   *
   * Search contacts favorite stations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUsersFavoriteStations$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsersFavoriteStations$Any$Response(params?: SearchUsersFavoriteStations$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<UserFavoriteStationsList>> {
    return searchUsersFavoriteStations$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search contacts favorite stations.
   *
   * Search contacts favorite stations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUsersFavoriteStations$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchUsersFavoriteStations$Any(params?: SearchUsersFavoriteStations$Any$Params, context?: HttpContext): Observable<UserFavoriteStationsList> {
    return this.searchUsersFavoriteStations$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserFavoriteStationsList>): UserFavoriteStationsList => r.body)
    );
  }

  /** Path part for operation `searchDiffusionLists()` */
  static readonly SearchDiffusionListsPath = '/users/diffusionlist/search';

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDiffusionLists()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDiffusionLists$Response(params?: SearchDiffusionLists$Params, context?: HttpContext): Observable<StrictHttpResponse<DiffusionListPaged>> {
    return searchDiffusionLists(this.http, this.rootUrl, params, context);
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDiffusionLists$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchDiffusionLists(params?: SearchDiffusionLists$Params, context?: HttpContext): Observable<DiffusionListPaged> {
    return this.searchDiffusionLists$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiffusionListPaged>): DiffusionListPaged => r.body)
    );
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDiffusionLists$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchDiffusionLists$Any$Response(params?: SearchDiffusionLists$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<DiffusionListPaged>> {
    return searchDiffusionLists$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search diffusion lists, with pagination.
   *
   * Search diffusion lists, with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDiffusionLists$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchDiffusionLists$Any(params?: SearchDiffusionLists$Any$Params, context?: HttpContext): Observable<DiffusionListPaged> {
    return this.searchDiffusionLists$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<DiffusionListPaged>): DiffusionListPaged => r.body)
    );
  }

  /** Path part for operation `createDiffusionList()` */
  static readonly CreateDiffusionListPath = '/users/diffusionlist';

  /**
   * Create a diffusion list.
   *
   * Create a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDiffusionList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiffusionList$Response(params: CreateDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a diffusion list.
   *
   * Create a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDiffusionList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDiffusionList(params: CreateDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.createDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `retrieveDiffusionList()` */
  static readonly RetrieveDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * retrieve a diffusion list.
   *
   * retrieve a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveDiffusionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveDiffusionList$Response(params: RetrieveDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleDiffusionList>> {
    return retrieveDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve a diffusion list.
   *
   * retrieve a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveDiffusionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveDiffusionList(params: RetrieveDiffusionList$Params, context?: HttpContext): Observable<SingleDiffusionList> {
    return this.retrieveDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<SingleDiffusionList>): SingleDiffusionList => r.body)
    );
  }

  /** Path part for operation `updateDiffusionList()` */
  static readonly UpdateDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * Update a diffusion list.
   *
   * Update a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDiffusionList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiffusionList$Response(params: UpdateDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a diffusion list.
   *
   * Update a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDiffusionList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDiffusionList(params: UpdateDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.updateDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteDiffusionList()` */
  static readonly DeleteDiffusionListPath = '/users/diffusionlist/{uid}';

  /**
   * Delete a diffusion list.
   *
   * Delete a diffusion list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDiffusionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiffusionList$Response(params: DeleteDiffusionList$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteDiffusionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a diffusion list.
   *
   * Delete a diffusion list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDiffusionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDiffusionList(params: DeleteDiffusionList$Params, context?: HttpContext): Observable<void> {
    return this.deleteDiffusionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `findUserByLogin()` */
  static readonly FindUserByLoginPath = '/users/findByLogin';

  /**
   * Find if an user exists for this email.
   *
   * Used for the subscription contacts, this allows to see if an user exist them to know if it needs to be created before or not.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findUserByLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findUserByLogin$Response(params: FindUserByLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSummary>> {
    return findUserByLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * Find if an user exists for this email.
   *
   * Used for the subscription contacts, this allows to see if an user exist them to know if it needs to be created before or not.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findUserByLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findUserByLogin(params: FindUserByLogin$Params, context?: HttpContext): Observable<UserSummary> {
    return this.findUserByLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserSummary>): UserSummary => r.body)
    );
  }

}
